import housing from '@/assets/cockpit-housing-hd.webp';
import integrated from '@/assets/cockpit-housing-integrated-hd.webp';
import compact from '@/assets/cockpit-housing-integrated-compact-hd.webp';

// Contiguous parts of one housing share boundary pixels and vertical mapping.
// Narrow wings crop their outer empty surface instead of squeezing the contour.
export default function DesktopArmature({ careerRail = false }) {
  return <div className="armature-skin" aria-hidden="true">
    {[[0,520],[520,1132],[1652,520]].map(([x,width]) =>
      <div key={x} className="armature-skin-fragment">
        <svg viewBox={`${x} 375 ${width} 290`} preserveAspectRatio="none">
          {careerRail ? <image href={housing} width="2172" height="724"/> : <>
            <image className="armature-housing-wide" href={integrated} width="2172" height="724"/>
            <image className="armature-housing-compact" href={compact} width="2172" height="724"/>
          </>}
        </svg>
      </div>)}
  </div>;
}
